import { useState } from 'react';
import { type WaitingForPresentationPageProps } from '../../../chulak/ChulakSession';
import EmbeddedStatusScreen from '../shared/StatusScreen';
import { useEmbeddedCopy } from '../../../hooks/useEmbeddedCopy';
import { type ViewTable } from '../../types';

type View = 'waiting' | 'request';

/**
 * Continue in Yivi (desktop): the app scanned the code, waiting for approval.
 * Cancel goes back to the apps, or to a fresh code when there is one app.
 */
export default function EmbeddedDesktopWaitingPage({
  app,
  onBack,
  onRestart,
}: WaitingForPresentationPageProps) {
  const { t, pick } = useEmbeddedCopy();
  const [view, setView] = useState<View>('waiting');
  const appName = app?.name ?? '';

  const views: ViewTable<View> = {
    waiting: () => (
      <EmbeddedStatusScreen
        visual="app"
        app={app}
        badge="phone"
        title={t('embedded.waiting.title', { app: appName })}
        sub={t(pick('embedded.waiting.sub', 'embedded.waiting.subIssuance'))}
        secondary={{
          label: t('embedded.cancel'),
          onClick: onBack ?? onRestart,
        }}
        links={[
          {
            label: t('embedded.waiting.help'),
            onClick: () => setView('request'),
          },
        ]}
      />
    ),
    request: () => (
      <EmbeddedStatusScreen
        visual="help"
        title={t('embedded.request.title')}
        sub={t('embedded.request.sub', { app: appName })}
        primary={{ label: t('embedded.request.scanAgain'), onClick: onRestart }}
        secondary={{
          label: t('embedded.request.keepWaiting'),
          onClick: () => setView('waiting'),
        }}
      />
    ),
  };

  return views[view]();
}
